/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tabdata1Inputs */

const en_tabdata1 = /** @type {(inputs: Tabdata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

const pt_tabdata1 = /** @type {(inputs: Tabdata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados`)
};

/**
* | output |
* | --- |
* | "Data" |
*
* @param {Tabdata1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const tabdata1 = /** @type {((inputs?: Tabdata1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tabdata1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tabdata1(inputs)
	return pt_tabdata1(inputs)
});
export { tabdata1 as "tabData" }